export default __webpack_public_path__ + "static/media/6.9c076db6.svg";